/**
 * @flow
 * @relayHash 9ba44e2258a88c376abe02fb674eb70c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SendFeedbackInput = {|
  content: string,
  from: string,
|};
export type SendFeedbackMutationVariables = {|
  input: SendFeedbackInput
|};
export type SendFeedbackMutationResponse = {|
  +sendFeedback: ?{|
    +status: ?string
  |}
|};
export type SendFeedbackMutation = {|
  variables: SendFeedbackMutationVariables,
  response: SendFeedbackMutationResponse,
|};
*/


/*
mutation SendFeedbackMutation(
  $input: SendFeedbackInput!
) {
  sendFeedback(input: $input) {
    status
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendFeedbackInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sendFeedback",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendFeedbackPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SendFeedbackMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SendFeedbackMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SendFeedbackMutation",
    "id": null,
    "text": "mutation SendFeedbackMutation(\n  $input: SendFeedbackInput!\n) {\n  sendFeedback(input: $input) {\n    status\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '31f9e0a19bba9ae7aee0c0a88c85acf3';

module.exports = node;
